import React from "react";
import "./VariantTable.css";
import { FaPen, FaTrash, FaBox } from "react-icons/fa";

const VariantTable = ({ variants = [], onEdit, onDelete, canWrite = true }) => {
  if (!variants.length) {
    return (
      <div className="no-variants-message">
        <p>No variants available for this product yet.</p>
      </div>
    );
  }

  return (
    <div className="variant-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>Variant</th>
            <th>Price Summary</th>
            <th>Stock</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {variants.map((v) => {
            const attributes = v.attributes || {};
            const hasAttributes = Object.keys(attributes).length > 0;

            return (
              <tr key={v._id || v.id}>
                <td className="variant-info-cell">
                  <div className="variant-details">
                    <div className="variant-attributes">
                      {hasAttributes ? (
                        <>
                          {attributes.color && (
                            <span className="attr-tag">
                              {attributes.hex && (
                                <span 
                                  className="attr-color-dot" 
                                  style={{ backgroundColor: attributes.hex }}
                                ></span>
                              )}
                              Color: {attributes.color}
                            </span>
                          )}
                          {attributes.size && (
                            <span className="attr-tag">Size: {attributes.size}</span>
                          )}
                          {Object.entries(attributes).map(([key, value]) => {
                            if (key === 'color' || key === 'size' || key === 'hex') return null;
                            return <span key={key} className="attr-tag">{key}: {value}</span>;
                          })}
                        </>
                      ) : (
                        <span className="table-value-text">
                          {v.variant_Values || v.variant_Value || v.variantValue || "Standard"}
                        </span>
                      )}
                    </div>
                  </div>
                </td>
                <td>
                  <div className="table-price-wrapper">
                    <span className="table-price-main">₹{v.offer_price || v.price}</span>
                    {v.offer_price && v.offer_price < v.price && (
                      <div className="price-discount-row">
                        <span className="table-price-old">₹{v.price}</span>
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <span className={`stock-pill ${v.stock > 10 ? 'in-stock' : v.stock > 0 ? 'low-stock' : 'out-of-stock'}`}>
                    <FaBox size={12} /> {v.stock > 0 ? `${v.stock} pcs` : 'Sold out'}
                  </span>
                </td>
                <td>
                  <div className="table-actions">
                    {canWrite && (
                      <>
                        <button className="action-btn edit" onClick={() => onEdit(v)} title="Edit">
                          <FaPen />
                        </button>
                        <button className="action-btn delete" onClick={() => onDelete(v._id || v.id)} title="Delete">
                          <FaTrash />
                        </button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default VariantTable;
